module.exports = __webpack_public_path__ + "static/media/SathwikRai.19e4d9ab.svg";